import request from '@/utils/request'

// 查询自己的上架 Profile 产品
export function findAgentsProfileProducts(params) {
  return request({
    url: `/customer/agents_profile_products`,
    method: 'get',
    params
  })
}
